import styles from "./index.module.css";

type Props = {
  dayPrice: number;
  discount?: number | string;
  daysRange: string;
};

export const PriceComponent = ({ dayPrice, discount, daysRange }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div>{daysRange} days</div>
      <div>
        <span>€{dayPrice}</span>
        {discount && <div>-{discount}%</div>}
      </div>
      <div>per day</div>
    </div>
  );
};
